import { AppLanguageOptionsSubsetEnum } from "../../app/models/constants/app-language-options.const";

// Currently we do not need many customer specific overrides
// if those become more complex in the future, we might want to move them to separate json files instead
export const customerOverridesByLanguage: Record<
  string,
  Record<AppLanguageOptionsSubsetEnum, Record<string, unknown>>
> = {
  bmb: {
    de: {
      app: {
        title: "KI-Portal",
      },
      footer: {
        impressumUrl: "https://www.bmb.gv.at/Ministerium/Impressum.html",
        contactUrl: "https://www.bmb.gv.at/Ministerium/Kontakt.html",
        privacyPolicyUrl: "https://www.bmb.gv.at/Ministerium/Informationspflicht/Datenschutz.html",
      },
      pages: {
        landingPage: {
          title: "Willkommen im",
        },
      },
    },
    en: {
      app: {
        title: "AI Portal",
      },
      footer: {
        impressumUrl: "https://www.bmb.gv.at/Ministerium/Impressum.html",
        contactUrl: "https://www.bmb.gv.at/Ministerium/Kontakt.html",
        privacyPolicyUrl: "https://www.bmb.gv.at/en/Ministry/Information/Data-protection.html",
      },
      pages: {
        landingPage: {
          title: "Welcome to the",
        },
      },
    },
    fr: {
      app: {
        title: "Portail IA",
      },
      footer: {
        impressumUrl: "https://www.bmb.gv.at/Ministerium/Impressum.html",
        contactUrl: "https://www.bmb.gv.at/Ministerium/Kontakt.html",
        privacyPolicyUrl: "https://www.bmb.gv.at/Ministerium/Informationspflicht/Datenschutz.html",
      },
    },
  },
  bmluk: {
    de: {
      app: {
        title: "AI-Tools:Live",
      },
      companyTitle:
        "Bundesministerium für Land- und Forstwirtschaft, Klima- und Umweltschutz, Regionen und Wasserwirtschaft",
      aiNameAbbreviation: "AI-Chat",
      aiName: "Artificial Intelligence Chat",
      pages: {
        landingPage: {
          title: "",
          tooltip: {
            externalLinkWarning:
              "Sie verlassen die die AI-Tools:Live und werden zu einer externen Website weitergeleitet.",
          },
        },
      },
      global: {
        loadingPage: "AI-Tools:Live werden geladen...",
      },
      footer: {
        impressumUrl: "https://www.bmluk.gv.at/impressum.html",
        contactUrl: "https://www.bmluk.gv.at/kontakt.html",
        privacyPolicyUrl: "https://www.bmluk.gv.at/datenschutzinformationen.html",
      },
      feature: {
        chatbot: {
          link: "AI-Chat",
          breadCrumbTitle: "AI-Chat - Ihr smarter KI Assistent",
          title: "AI-Chat - Ihr smarter KI Assistent",
          landing: {
            title: "AI-Chat - Ihr smarter KI Assistent",
            description:
              "Ein AI-Chat ist ein virtueller Assistent, der mittels KI natürlichsprachliche Kommunikation ermöglicht und menschliche Teams unterstützt, etwa indem er Informationen bereitstellt, Fragen beantwortet oder Empfehlungen ausspricht!",
            buttonLabel: "Stellen Sie eine Frage",
          },
          webSearch: {
            disclaimer: {
              contentMarkdown:
                "Mit der Web-Search-Funktion vom AI-Chat werden öffentlich zugängliche Informationen aus dem Internet abgerufen.\n\nDie Ergebnisse dienen als Unterstützung, ihre Qualität kann variieren und sie sind kritisch zu prüfen.\n\nFachliche Bewertungen und Entscheidungen erfolgen eigenverantwortlich.\n\nPersonenbezogene Daten dürfen nur bei rechtlicher Zulässigkeit verarbeitet werden, und die Nutzung der Funktion erfolgt ausschließlich in Bereichen mit entsprechender fachlicher Expertise.\n\nDie Nutzung kann zusätzliche Kosten verursachen.",
            },
          },
        },
        transcription: {
          description:
            "Verwandeln Sie die Audiodateien Ihrer eigenen Diktate in klaren, lesbaren Text. Die Transkriptionsfunktion hilft Ihnen, Inhalte präzise zu dokumentieren. Nach Abschluss steht der fertige Text bequem zum Download bereit.",
          landing: {
            description:
              "Laden Sie die Audiodateien Ihrer eigenen Diktate hoch und lassen Sie die KI arbeiten. Eigene Diktate – in Sekundenschnelle wird Ihr Gesprochenes zu Text. Einfach, schnell und zuverlässig.",
          },
        },
      },
      newThread: {
        greeting: "Wie kann Ihnen der AI-Chat heute helfen?",
      },
    },
    en: {
      app: {
        title: "AI-Tools:Live",
      },
      companyTitle:
        "Federal Ministry of Agriculture and Forestry, Climate and Environmental Protection, Regions and Water Management",
      aiNameAbbreviation: "AI-Chat",
      aiName: "Artificial Intelligence Chat",
      pages: {
        landingPage: {
          title: "",
          tooltip: {
            externalLinkWarning: "You are leaving the AI-Tools:Live and will be redirected to an external website.",
          },
        },
      },
      global: {
        loadingPage: "AI-Tools:Live are loading...",
      },
      footer: {
        impressumUrl: "https://www.bmluk.gv.at/en/imprint.html",
        contactUrl: "https://www.bmluk.gv.at/en/contact.html",
        privacyPolicyUrl: "https://www.bmluk.gv.at/en/privacy-statement.html",
      },
      feature: {
        chatbot: {
          link: "AI-Chat",
          breadCrumbTitle: "AI-Chat - Your smart AI assistant",
          title: "AI-Chat",
          landing: {
            title: "AI-Chat – Your smart AI assistant",
            description:
              "Experience communication in a whole new way! AI-Chat, the artificially intelligent assistant, provides real-time answers – precise, clear, and efficient. Just ask and explore the possibilities of cutting-edge AI!",
            buttonLabel: "Ask AI-Chat a question",
          },
          webSearch: {
            disclaimer: {
              contentMarkdown:
                "Mit der Web-Search-Funktion von AI-Chat werden öffentlich zugängliche Informationen aus dem Internet abgerufen.\n\nDie Ergebnisse dienen als Unterstützung, ihre Qualität kann variieren und sie sind kritisch zu prüfen.\n\nFachliche Bewertungen und Entscheidungen erfolgen eigenverantwortlich.\n\nPersonenbezogene Daten dürfen nur bei rechtlicher Zulässigkeit verarbeitet werden, und die Nutzung der Funktion erfolgt ausschließlich in Bereichen mit entsprechender fachlicher Expertise.\n\nDie Nutzung kann zusätzliche Kosten verursachen.",
            },
          },
        },
        transcription: {
          description:
            "Turn the audio files of your own dictations into clear, readable text. The transcription feature helps you document content precisely. Once completed, the final text is easily available for download.",
          landing: {
            description:
              "Upload the audio files of your own dictations and let the AI work. Spoken words are converted to text in seconds. Simple, fast, and reliable.",
          },
        },
      },
      newThread: {
        greeting: "How can AI-Chat assist you today?",
      },
    },
    fr: {
      app: {
        title: "AI-Tools:Live En direct",
      },
      companyTitle:
        "Federal Ministry of Agriculture and Forestry, Climate and Environmental Protection, Regions and Water Management",
      aiNameAbbreviation: "AI-Chat",
      aiName: "Chat d'intelligence artificielle",
      pages: {
        landingPage: {
          title: "",
          tooltip: {
            externalLinkWarning: "Vous quittez AI-Tools:Live et serez redirigé vers un site externe.",
          },
        },
      },
      global: {
        loadingPage: "AI-Tools:Live est en cours de chargement...",
      },
      footer: {
        impressumUrl: "https://www.bmluk.gv.at/en/imprint.html",
        contactUrl: "https://www.bmluk.gv.at/en/contact.html",
        privacyPolicyUrl: "https://www.bmluk.gv.at/en/privacy-statement.html",
      },
      feature: {
        chatbot: {
          link: "IA-Chat",
          breadCrumbTitle: "IA-Chat - Votre assistant IA intelligent",
          title: "IA-Chat - Votre assistant IA intelligent",
          landing: {
            title: "IA-Chat - Votre assistant IA intelligent",
            description:
              "Découvrez une nouvelle façon de communiquer ! IA-Chat, l'assistant intelligent, fournit des réponses en temps réel – précises, claires et efficaces. Posez vos questions et explorez les possibilités de l'IA de pointe !",
            buttonLabel: "Poser une question à IA-Chat",
          },
          webSearch: {
            disclaimer: {
              contentMarkdown:
                "Avec la fonction de recherche Web de IA-Chat, des informations accessibles au public sur Internet sont récupérées.\n\nLes résultats servent de support, leur qualité peut varier et ils doivent être évalués de manière critique.\n\nLes évaluations et décisions professionnelles sont prises de manière autonome.\n\nLes données personnelles ne doivent être traitées que si la législation le permet, et l'utilisation de la fonction se fait uniquement dans des domaines avec une expertise professionnelle appropriée.\n\nL'utilisation peut entraîner des coûts supplémentaires.",
            },
          },
        },
        transcription: {
          description:
            "Transformez les fichiers audio de vos propres dictées en texte clair et lisible. La fonction de transcription vous aide à documenter le contenu avec précision. Une fois terminé, le texte final est facilement disponible au téléchargement.",
          landing: {
            description:
              "Téléchargez les fichiers audio de vos propres dictées et laissez l’IA travailler. Les paroles sont transformées en texte en quelques secondes. Simple, rapide et fiable.",
          },
        },
      },
      newThread: {
        greeting: "Comment IA-Chat peut-il vous aider aujourd'hui ?",
      },
    },
  },
};
